import { api } from "../api/api";
import { ImportMode } from "../redux/commAutoPolicy/commAutoRiskProfile/iftaImport.types";
import { IFTA_PREVIEW_ENDPOINT } from "../views/customers/components/Policies/CommAutomobilePolicy/RiskProfile/IftaImport/constants/iftaConstants";

/**
 * Builds the multipart `FormData` for the IFTA quarterly import preview request.
 *
 * - Each file is appended under the key `files`.
 * - `incremental_number`, `mode`, and `expected_quarters` (default 4) are always appended.
 * - `customer_policy_id` and `lead_id` are appended whenever each is present
 *   (no mutual exclusivity is enforced — Requirement 3.2).
 *
 * The `Content-Type` header is intentionally NOT set here; axios/the browser sets
 * the multipart boundary automatically (Requirement 3.1).
 */
export const buildIftaImportFormData = (args: {
  files: File[];
  customerPolicyId?: number;
  leadId?: string | null;
  incrementalNumber: number;
  mode: ImportMode;
  expectedQuarters?: number;
}): FormData => {
  const {
    files,
    customerPolicyId,
    leadId,
    incrementalNumber,
    mode,
    expectedQuarters = 4,
  } = args;

  const formData = new FormData();

  for (const file of files) {
    formData.append("files", file);
  }

  formData.append("incremental_number", String(incrementalNumber));
  formData.append("mode", mode);
  formData.append("expected_quarters", String(expectedQuarters));

  if (customerPolicyId !== undefined && customerPolicyId !== null) {
    formData.append("customer_policy_id", String(customerPolicyId));
  }

  if (leadId !== undefined && leadId !== null) {
    formData.append("lead_id", leadId);
  }

  return formData;
};

/**
 * Posts the prepared multipart `FormData` to the IFTA preview endpoint.
 *
 * Does not set `Content-Type` manually so axios/the browser can set the
 * multipart boundary (Requirement 3.1).
 */
export const postIftaImportPreview = (fd: FormData) =>
  api.post(IFTA_PREVIEW_ENDPOINT, fd);
